<template>
  <div id="main-base">
      <nav id="topbar">
          <span class="title" v-hammer:press="fakeLogout">First Home Saver</span>
          <span class="page">{{ pageName }}</span>
      </nav>
      <main>
          <div class="inner">
              <router-view/>
          </div>
      </main>
      <nav id="tabnav">
          <router-link to="/main/add-funds"><i class="fas fa-plus-circle"></i>Add Funds</router-link>
          <router-link to="/main/set-goal"><i class="fas fa-calculator"></i>Set Goal</router-link>
          <router-link to="/main/progress"><i class="fas fa-chart-bar"></i>Progress</router-link>
          <router-link to="/main/pre-qualify"><i class="fas fa-check-circle"></i>Pre-Qualify</router-link>
          <router-link to="/main/settings"><i class="fas fa-cog"></i>Settings</router-link>
      </nav>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
    name: 'main-base',
    computed: {
        ...mapState(['pageName']),
    },
    methods: {
        fakeLogout() {
            this.$store.dispatch('fullReset')
            this.$router.push('/setup/login')
        }
    },
}
</script>
<style lang="scss">
#main-base {
    text-align: center;
    color: #000;
    height: 100%;

    display: grid;
    grid-template-rows: 60px 1fr 65px;

    main {
        box-sizing: border-box;
        overflow-y: auto;

        .inner {
            min-height: 100%;
            display: flex;
            flex-flow: column nowrap;
        }


        .nav-buttons {
            .grad-button {
                margin-bottom: 16px;
                padding: 10px 12px;

                i {
                    font-size: 32px;
                }
            }
        }
    }
}

#topbar {
    box-sizing: border-box;
    display: grid;
    background: white;
    width: 100%;
    padding: 0 8px 8px;
    align-items: end;

    grid-template-columns: auto 1fr;

    .title {
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
    }
    .page {
        text-align: right;
        font-size: 14px;
        font-weight: bold;
    }
}

#tabnav {
    background-image: linear-gradient(to bottom, #012F4E 0%, #011E2E 100%);
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: 0 8px;
    align-items: center;

    a {
        i {
            font-size: 24px;
            display: block;
        }
        color: white;
        text-decoration: none;
        font-size: 10px;
    }

}
</style>
